var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"df205fa95adfb8cd2a84d5ac7d0b13c362fb02ef"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["eth-dapp-v2@staderlabs"]={id:"df205fa95adfb8cd2a84d5ac7d0b13c362fb02ef"};
      